
export function getFullscreenElement() {
    return document.fullscreenElement || document.webkitFullscreenElement || null;
}

export async function requestDocumentFullscreen() {
    const el = document.documentElement;
    if (!el || getFullscreenElement()) return;
    if (typeof el.requestFullscreen === 'function') {
        try {
            await el.requestFullscreen({ navigationUI: 'hide' });
        } catch {
            await el.requestFullscreen();
        }
        return;
    }
    if (typeof el.webkitRequestFullscreen === 'function') {
        await el.webkitRequestFullscreen();
    }
}

export async function exitDocumentFullscreen() {
    if (!getFullscreenElement()) return;
    if (typeof document.exitFullscreen === 'function') {
        await document.exitFullscreen();
        return;
    }
    if (typeof document.webkitExitFullscreen === 'function') {
        await document.webkitExitFullscreen();
    }
}

/** Fullscreen for a specific element (e.g. embedded map). Prefer over {@link requestDocumentFullscreen} when only a region should expand. */
export async function requestElementFullscreen(el) {
    if (!el || getFullscreenElement()) return;
    if (typeof el.requestFullscreen === 'function') {
        try {
            await el.requestFullscreen({ navigationUI: 'hide' });
        } catch {
            await el.requestFullscreen();
        }
        return;
    }
    if (typeof el.webkitRequestFullscreen === 'function') {
        await el.webkitRequestFullscreen();
    }
}
